import axios from "axios";
import { getStorageKey } from "utils/storageHelpers";

export const axiosInstance = axios.create({
  baseURL: "https://api-dev.safome.co/api/v1/",
  // baseURL: "http://10.5.50.23:8002/api/v1/",
});

axiosInstance.interceptors.request.use(
  (request) => {
    const accessToken = localStorage.getItem(getStorageKey("authToken"));

    if (accessToken) {
      request.headers["Authorization"] = "Bearer " + accessToken;
    }

    if (request.data instanceof FormData) {
      delete request.headers["Content-Type"];
    } else {
      request.headers["Content-Type"] = "application/json";
    }

    return request;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error?.config;
    if (error?.response?.status === 401 && !originalRequest?.sent) {
      localStorage.removeItem(getStorageKey("authToken"));
      localStorage.removeItem(getStorageKey("profile"));
      window.location.href = "/auth/signin";
      originalRequest.sent = true;
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
